var _path, _rect, _rect2, _path2, _g, _path3, _path4, _path5, _rect3, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 521,
    height: 333,
    viewBox: "0 0 521 333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54956 21.8183C7.54956 14.419 13.5479 8.42065 20.9472 8.42065H499.913C507.312 8.42065 513.311 14.419 513.311 21.8183V311.466C513.311 318.865 507.312 324.864 499.913 324.864H20.9472C13.5479 324.864 7.54956 318.865 7.54956 311.466V21.8183Z",
    fill: "#FFEEE9",
    stroke: "#FFEEE9",
    strokeWidth: 8.10204
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.3376,
    y: 26.3376,
    width: 62.3248,
    height: 42.3248,
    fill: "#171C60",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 114.729,
    y: 27.2712,
    width: 377.719,
    height: 23.4777,
    fill: "#A3BBDC",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9472 16.5268H499.913C502.835 16.5268 505.205 18.8959 505.205 21.8183V311.466C505.205 314.389 502.835 316.758 499.913 316.758H20.9472C18.0248 316.758 15.6557 314.389 15.6557 311.466V21.8183C15.6557 18.8959 18.0248 16.5268 20.9472 16.5268ZM20.9472 2.6817C10.3784 2.6817 1.81061 11.2495 1.81061 21.8183V311.466C1.81061 322.035 10.3784 330.603 20.9472 330.603H499.913C510.482 330.603 519.05 322.035 519.05 311.466V21.8183C519.05 11.2494 510.482 2.6817 499.913 2.6817H20.9472Z",
    fill: "white",
    stroke: "#FFEEE9",
    strokeWidth: 3.37585
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 192.338,
    y: 69.5388,
    width: 36.4852,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 248.079,
    y: 69.5388,
    width: 244.583,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 192.338,
    y: 101.883,
    width: 36.4852,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 248.079,
    y: 101.883,
    width: 244.583,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 192.338,
    y: 134.226,
    width: 36.4852,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 248.079,
    y: 134.226,
    width: 244.583,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 192.338,
    y: 166.57,
    width: 36.4852,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 248.079,
    y: 166.57,
    width: 244.583,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 192.338,
    y: 198.914,
    width: 36.4852,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 248.079,
    y: 198.914,
    width: 244.583,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 192.338,
    y: 231.258,
    width: 36.4852,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 248.079,
    y: 231.258,
    width: 244.583,
    height: 14.7266,
    fill: "#FFA993",
    stroke: "#FFEEE9",
    strokeWidth: 0.67517
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.807 238.956L102.798 238.962C102.324 239.314 101.857 239.66 101.399 240C100.94 239.66 100.473 239.314 99.9991 238.962L99.9905 238.956C96.7529 236.557 93.1631 233.897 89.3661 230.905C97.035 226.22 105.024 220.551 112.758 213.538L113.821 212.573C120.926 206.23 128.1 198.741 134.531 189.589C146.439 172.645 156.087 149.465 155.92 116.755L155.912 115.218L154.434 114.832C135.392 109.859 112.626 107.849 101.457 107.517L101.399 107.515L101.34 107.517C90.1714 107.849 67.4057 109.859 48.363 114.832L46.8851 115.218L46.8772 116.755C46.7105 149.465 56.3584 172.645 68.2662 189.589C73.3073 196.763 78.8045 202.914 84.3669 208.293C80.301 211.097 76.2325 213.579 72.2374 215.818C50.5779 194.133 29.3881 160.446 33.0373 105.338C55.8992 97.1406 87.8715 94.3588 101.379 94.0005L101.399 94L101.418 94.0005C114.925 94.3588 146.898 97.1406 169.76 105.338C172.565 147.701 160.693 177.369 145.269 198.649C134.501 213.505 121.961 224.329 111.323 232.55C108.302 234.885 105.439 237.006 102.807 238.956Z",
    fill: "#1956A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.125 176.029C76.125 162.766 86.8033 152.014 99.9756 152.014C113.148 152.014 123.826 162.766 123.826 176.029V177.95H76.125V176.029Z",
    fill: "#1956A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.984 135.528C111.984 142.337 106.502 147.856 99.7402 147.856C92.9782 147.856 87.4966 142.337 87.4966 135.528C87.4966 128.72 92.9782 123.2 99.7402 123.2C106.502 123.2 111.984 128.72 111.984 135.528Z",
    fill: "#1956A8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.72949,
    y: 278.525,
    width: 501.171,
    height: 42.2675,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5522 299.34V297.295L36.3684 292.306V294.484L26.9982 298.33L36.3684 302.212V304.39L24.5522 299.34ZM39.1064 299.34V297.295L50.9226 292.306V294.484L41.5524 298.33L50.9226 302.212V304.39L39.1064 299.34ZM53.6607 299.34V297.295L65.4769 292.306V294.484L56.1067 298.33L65.4769 302.212V304.39L53.6607 299.34ZM68.2149 299.34V297.295L80.0311 292.306V294.484L70.6609 298.33L80.0311 302.212V304.39L68.2149 299.34ZM82.7691 299.34V297.295L94.5853 292.306V294.484L85.2151 298.33L94.5853 302.212V304.39L82.7691 299.34ZM97.3234 299.34V297.295L109.14 292.306V294.484L99.7694 298.33L109.14 302.212V304.39L97.3234 299.34ZM111.878 299.34V297.295L123.694 292.306V294.484L114.324 298.33L123.694 302.212V304.39L111.878 299.34ZM126.432 299.34V297.295L138.248 292.306V294.484L128.878 298.33L138.248 302.212V304.39L126.432 299.34ZM140.986 299.34V297.295L152.802 292.306V294.484L143.432 298.33L152.802 302.212V304.39L140.986 299.34ZM155.54 299.34V297.295L167.356 292.306V294.484L157.986 298.33L167.356 302.212V304.39L155.54 299.34ZM170.095 299.34V297.295L181.911 292.306V294.484L172.541 298.33L181.911 302.212V304.39L170.095 299.34ZM184.649 299.34V297.295L196.465 292.306V294.484L187.095 298.33L196.465 302.212V304.39L184.649 299.34ZM199.203 299.34V297.295L211.019 292.306V294.484L201.649 298.33L211.019 302.212V304.39L199.203 299.34ZM213.757 299.34V297.295L225.573 292.306V294.484L216.203 298.33L225.573 302.212V304.39L213.757 299.34ZM228.311 299.34V297.295L240.128 292.306V294.484L230.757 298.33L240.128 302.212V304.39L228.311 299.34ZM242.866 299.34V297.295L254.682 292.306V294.484L245.312 298.33L254.682 302.212V304.39L242.866 299.34ZM257.42 299.34V297.295L269.236 292.306V294.484L259.866 298.33L269.236 302.212V304.39L257.42 299.34ZM271.974 299.34V297.295L283.79 292.306V294.484L274.42 298.33L283.79 302.212V304.39L271.974 299.34ZM286.528 299.34V297.295L298.345 292.306V294.484L288.974 298.33L298.345 302.212V304.39L286.528 299.34ZM301.083 299.34V297.295L312.899 292.306V294.484L303.529 298.33L312.899 302.212V304.39L301.083 299.34ZM315.637 299.34V297.295L327.453 292.306V294.484L318.083 298.33L327.453 302.212V304.39L315.637 299.34ZM330.191 299.34V297.295L342.007 292.306V294.484L332.637 298.33L342.007 302.212V304.39L330.191 299.34ZM344.745 299.34V297.295L356.561 292.306V294.484L347.191 298.33L356.561 302.212V304.39L344.745 299.34ZM359.3 299.34V297.295L371.116 292.306V294.484L361.746 298.33L371.116 302.212V304.39L359.3 299.34ZM373.854 299.34V297.295L385.67 292.306V294.484L376.3 298.33L385.67 302.212V304.39L373.854 299.34ZM388.408 299.34V297.295L400.224 292.306V294.484L390.854 298.33L400.224 302.212V304.39L388.408 299.34ZM402.962 299.34V297.295L414.778 292.306V294.484L405.408 298.33L414.778 302.212V304.39L402.962 299.34ZM417.516 299.34V297.295L429.333 292.306V294.484L419.962 298.33L429.333 302.212V304.39L417.516 299.34ZM432.071 299.34V297.295L443.887 292.306V294.484L434.517 298.33L443.887 302.212V304.39L432.071 299.34ZM446.625 299.34V297.295L458.441 292.306V294.484L449.071 298.33L458.441 302.212V304.39L446.625 299.34ZM461.179 299.34V297.295L472.995 292.306V294.484L463.625 298.33L472.995 302.212V304.39L461.179 299.34ZM475.733 299.34V297.295L487.55 292.306V294.484L478.179 298.33L487.55 302.212V304.39L475.733 299.34ZM490.288 299.34V297.295L502.104 292.306V294.484L492.734 298.33L502.104 302.212V304.39L490.288 299.34Z",
    fill: "#E8EFFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermis);
export default __webpack_public_path__ + "static/media/Permis.06b009e3a0998115043b019a1a45f15a.svg";
export { ForwardRef as ReactComponent };